import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { ScheduledPostErrorType } from 'api/clients/ScheduledPostsClient'
import useOpenWindowSafely from 'hooks/useOpenWindowSafely'
import { useInitiateOauth } from 'hooks/useInitiateOauth'

export const useRefreshAccount = (integration?: ExternalIntegration) => {
  const { initiateOauth } = useInitiateOauth()

  const refreshAccount = () => {
    if (!integration) return
    initiateOauth(integration.provider, integration.id as number)
  }

  return {
    refreshAccount,
  }
}

export const useErrorAction = ({
  integration,
  errorType,
}: {
  integration?: ExternalIntegration
  errorType?: ScheduledPostErrorType
}) => {
  const { refreshAccount } = useRefreshAccount(integration)
  const openWindowSafely = useOpenWindowSafely()

  const errorAction = () => {
    switch (errorType) {
      case ScheduledPostErrorType.MediaFormatError:
        return {
          label: 'See Requirements',
          onPress: () =>
            openWindowSafely(
              'https://help.blaze.ai/en/articles/9911718-image-and-video-file-requirements-by-platform-connection',
            ),
        }
      case ScheduledPostErrorType.AuthenticationError:
      case ScheduledPostErrorType.AuthorizationError:
      case ScheduledPostErrorType.UnknownError:
        return {
          label: 'Reauthenticate',
          onPress: refreshAccount,
        }
    }
  }

  return { errorAction }
}
